import { render } from "./EditPlaylist.vue?vue&type=template&id=2c8ef242&scoped=true"
import script from "./EditPlaylist.vue?vue&type=script&lang=js"
export * from "./EditPlaylist.vue?vue&type=script&lang=js"

import "./EditPlaylist.vue?vue&type=style&index=0&id=2c8ef242&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8ef242"]])

export default __exports__